import script from "./base-search-exact.vue?vue&type=script&setup=true&lang=ts"
export * from "./base-search-exact.vue?vue&type=script&setup=true&lang=ts"

import "./base-search-exact.vue?vue&type=style&index=0&id=08eff339&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08eff339"]])

export default __exports__